/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2020 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export enum NodeEvent
{
    SIZE_CHANGED = 'size-changed',
    POSITION_CHANGED = 'position-changed',
    ANCHOR_CHANGED = 'anchor-changed',
    ACTIVE_HIERARCHY_CHANGED = 'active-in-hierarchy-changed',
    // CHILD
    CHILD_ADDED = 'child-added',
    CHILD_REMOVED = 'child-removed',
    CHILD_REORDER = 'child-reorder'
}
